function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { useAction } from 'hooks';
import Button from 'components/Form/Button';
import * as actions from '../../../actions';
import * as constants from '../../../constants';
import * as selectors from '../../../selectors';
import messages from '../../../messages';
import styles from '../DownloadDataModal.pcss';
const Connect = ({ onSetStep })=>{
    const connect = useAction(actions.connectBlueCable);
    const onConnect = ()=>{
        connect();
        onSetStep(2);
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("p", {
                className: "modal__info",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.connectBlueCable.info))
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.illustration,
                children: /*#__PURE__*/ _jsx("img", {
                    src: "/assets/svg/connect-by-blue-cable.svg",
                    className: "w-100",
                    alt: ""
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "modal__actions",
                children: /*#__PURE__*/ _jsx(Button, {
                    styleModifier: "primary",
                    labelMessage: messages.buttons.next,
                    className: "btn--block btn--filled",
                    onClick: onConnect
                })
            })
        ]
    });
};
const StartCheckingConnection = ({ onSetComponent })=>{
    const connectionId = useSelector(selectors.connectionId);
    const connectionStatus = useSelector(selectors.connectionStatus);
    const startCheckingConnection = useAction(actions.startCheckingConnection);
    useEffect(()=>{
        if (connectionId) {
            startCheckingConnection(connectionId);
        }
    }, [
        connectionId
    ]);
    useEffect(()=>{
        if (connectionStatus === constants.CONNECTION_STATUSES.IN_PROGRESS || connectionStatus === constants.CONNECTION_STATUSES.SUCCESS) {
            onSetComponent('Downloading');
        }
    }, [
        connectionStatus
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("p", {
                className: "modal__info",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.connectBlueCable.pressM))
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.illustration,
                children: /*#__PURE__*/ _jsx("img", {
                    src: "/assets/svg/press-m-button.svg",
                    alt: ""
                })
            })
        ]
    });
};
const ConnectBlueCable = ({ onSetComponent })=>{
    const [step, setStep] = useState(1);
    const Component = step === 1 ? Connect : StartCheckingConnection;
    const onChooseConnection = ()=>{
        onSetComponent('ChooseConnection');
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.modal__content,
        children: [
            /*#__PURE__*/ _jsx("h3", {
                className: "modal__subheader ",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.howToStartConnection))
            }),
            /*#__PURE__*/ _jsx(Component, {
                onSetComponent: onSetComponent,
                onSetStep: setStep
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.divider,
                children: /*#__PURE__*/ _jsx("span", {
                    className: styles.divider__text,
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.or))
                })
            }),
            /*#__PURE__*/ _jsx(Button, {
                styleModifier: "transparent",
                labelMessage: messages.buttons.changeDeviceType,
                className: "btn--no-size text--primary m-0",
                onClick: onChooseConnection
            })
        ]
    });
};
export default ConnectBlueCable;
